import { useTranslation } from 'react-i18next';
import { useFetchUser, useFetchUserById } from '../../../../queries';
import { useBookingFormDefaultValues } from '../../hooks/useBookingFormDefaultValues';
import { useBookingResourceConfiguration } from '../../hooks/useBookingResourceConfiguration';
import { getInitialAttendees } from '../../hooks/helpers';
import { JxtBookingFormContent } from '../JxtBookingFormContent';
import { IJxtBookingForm } from './types';

/**
 * Resolves everything the form is a function of - the resource configuration, the default values,
 * the initial attendee chips - and only then mounts the form itself. Doing the resolution in a
 * parent is what lets the form below be a plain top-down render: it receives ready data and never
 * has to reconfigure itself afterwards.
 */
export const JxtBookingForm = (props: IJxtBookingForm) => {
  const { bookingToEdit, bookingFormPreset, moveFormOverride } = props;
  const { t } = useTranslation();
  const { user } = useFetchUser();
  const { user: organizerInPreset } = useFetchUserById(bookingFormPreset?.organizerId);
  const { resourceConfiguration, isLoading } = useBookingResourceConfiguration(
    bookingFormPreset?.resource,
    bookingToEdit
  );
  const derivedDefaultValues = useBookingFormDefaultValues(bookingFormPreset, resourceConfiguration, bookingToEdit);
  const defaultValues = moveFormOverride?.formData ?? derivedDefaultValues;

  if (isLoading || !defaultValues) {
    return null;
  }

  return (
    <JxtBookingFormContent
      {...props}
      defaultValues={defaultValues}
      resourceConfiguration={resourceConfiguration}
      initialAttendees={getInitialAttendees({
        bookingToEdit,
        moveFormOverride,
        isZone: resourceConfiguration?.isZone,
        user,
        organizerInPreset,
        youLabel: t<string>('you'),
      })}
    />
  );
};

export default JxtBookingForm;
